// Autogenerated by Hanako
import { Debug } from '../../views/ts/components/Debug';
import { Dropdown } from '../../views/ts/components/Dropdown';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { MasonryGrid } from '../../views/ts/components/MasonryGrid';
import { Menu } from '../../views/twig/components/Menu';
import { RGPDConsent } from '../../views/twig/components/RGPDConsent';
import { Project } from '../../views/twig/pages/singles/project';
(new Debug()).init();
(new Dropdown()).init();
(new LazyLoader()).init();
(new MasonryGrid()).init();
(new Menu()).init();
(new RGPDConsent()).init();
(new Project()).init();
